import React from "react";

import { Image } from "Components/atoms/Image";
import { Typography } from "Components/atoms/Typography";
import { RandomBackgroundSection } from "Components/molecules/RandomBackgroundSection";
import { SearchFlightsMobile } from "../../SearchFlights/Mobile";
import { imagesBackgroundBanner } from "shared/config/imagesBackgroundBannerConfig";
import { HeroContentWrapperMobile } from "./styles";
import PlaneIconImage from "assets/images/icons/plane.png";
import { theme } from "styles/theme";
import { AdBannerContainer } from "Components/molecules/AdBanner";

/**
 * Componente HeroSectionMobile
 *
 * Exibe uma seção heroica otimizada para dispositivos móveis.
 */
export const HeroSectionMobile: React.FC = () => {
  const images = imagesBackgroundBanner.filter(
    (i) => i.indexOf("mobile") !== -1,
  );

  return (
    <RandomBackgroundSection images={images} height="820px">
      <HeroContentWrapperMobile>
        <Image src={PlaneIconImage} alt="Ícone de avião" width="54px" />
        <h1
          style={{
            fontSize: theme.fontSizes.lg,
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          Compare e encontre as passagens aéreas mais baratas
        </h1>
      </HeroContentWrapperMobile>

      <SearchFlightsMobile />

      <AdBannerContainer
        slotId="div-gpt-ad-1748862973438-0"
        adUnit="/27140001/2024-home-mobile-interface-320x50"
        sizes={[[320, 50]]}
        marginTop={30}
        marginBottom={0}
      />
    </RandomBackgroundSection>
  );
};
